<template>
	<div class="container" id="FeelingsLog" style="max-width: 730px;">
		<div class="page-header gold mt-4 mb-2">
      <back-btn to="/dashboard"></back-btn>
      <h3 class="mb-0">Dreams Log</h3>
		</div>

		<div class="row">
			<div class="w-100">
				<dreams-log :userid="parseInt(this.$route.params.user_id)" :limit="200" />
			</div>
		</div>
	</div>
</template>

<script>
import DreamsLog from '../components/DreamsLog.vue';
import BackBtn from "@/components/BackBtn.vue";

export default {
	name: 'Dreams',
	components: {
    BackBtn,
		DreamsLog,
	},

	data() {
		return {};
	},

	methods: {},

	mounted() {},

	computed: {},
	watch: {},
};
</script>

<style scoped>
.page-header {
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 14px;
  position: relative;
}
</style>
